import { useEffect, useRef } from "react";
import "swagger-ui-dist/swagger-ui.css";
// Subpath sem tipos próprios; o bundle UMD expõe SwaggerUIBundle como default.
// Usamos o bundle (não o standalone) e o layout BaseLayout pra embutir sem a
// topbar do Swagger - a página já vive dentro do shell/branding do app.
// @ts-expect-error - sem declaração de tipos pro subpath do bundle
import SwaggerUIBundle from "swagger-ui-dist/swagger-ui-bundle.js";

interface Props {
  appName: string;
  onClose: () => void;
}

/**
 * Página /integracao - documentação navegável (Swagger UI) das rotas públicas
 * /v1, renderizada a partir de /api/openapi.json. Fica dentro do shell do app
 * (cabeçalho + tema), então herda a identidade visual da plataforma.
 */
export function ApiDocsPage({ appName, onClose }: Props) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    SwaggerUIBundle({
      url: "/api/openapi.json",
      domNode: containerRef.current,
      deepLinking: true,
      presets: [SwaggerUIBundle.presets.apis],
      layout: "BaseLayout",
      tryItOutEnabled: true,
      persistAuthorization: true,
    });
  }, []);

  return (
    <div className="about-page api-docs-page" role="dialog" aria-label="API de Integração">
      <header className="about-header">
        <h1>{appName} - API de Integração</h1>
        <button className="about-close" onClick={onClose} aria-label="Fechar">
          ×
        </button>
      </header>
      <section className="about-section">
        <p className="dim">
          Rotas públicas autenticadas por API key (Bearer). Crie uma chave em Admin → API e clique em
          “Authorize” abaixo pra testar direto por aqui.
        </p>
      </section>
      <div ref={containerRef} className="swagger-container" />
    </div>
  );
}
